'use strict';

const sportCategories = require('./sportCategories');
const tribeCategories = require('./tribeCategories');
const getCategoryFromSport = require('./getCategoryFromSport');

module.exports = {
  SPORT_CATEGORIES: {
    sportCategories,
    tribeCategories,
    getCategoryFromSport,
  },
};
